import React from 'react';
import { Link } from 'react-router-dom';
import CourseStep from './CourseStep';
import { IconCheck, IconPlay, IconArrowRight, IconLock } from './Icons';

/**
 * A video block in the course path: small preview thumbnail + meta.
 * Links to the full lesson player. Locked steps are not clickable.
 */
const VideoStep = ({ topicId, courseId, lesson, stepNo, watched, locked, active, isLast, anchorId }) => {
  const status = watched ? 'done' : locked ? 'locked' : 'active';
  const node = watched ? <IconCheck size={15} /> : locked ? <IconLock size={13} /> : stepNo;
  // Videos stay re-watchable even when done — only locked videos are blocked.
  const interactive = !locked;

  const inner = (
    <>
      <div className="ac-vstep-thumb">
        <img src={lesson.preview} alt={lesson.title} className="ac-vstep-thumb-img" />
        {locked ? (
          <span className="ac-vstep-lock">
            <IconLock size={16} />
          </span>
        ) : (
          <span className="ac-vstep-play">
            <IconPlay size={18} />
          </span>
        )}
        <span className="ac-vstep-dur">{lesson.duration}</span>
      </div>

      <div className="ac-vstep-info">
        <span className="ac-step-kicker">Video</span>
        <h3 className="ac-vstep-title">{lesson.title}</h3>
        <span className={`ac-step-state ${watched ? 'is-done' : ''} ${active ? 'is-active' : ''}`}>
          {watched ? 'Watched' : locked ? 'Locked' : 'Start now'}
        </span>
      </div>

      {interactive && (
        <span className="ac-vstep-go">
          <IconArrowRight size={16} />
        </span>
      )}
    </>
  );

  return (
    <CourseStep status={status} icon={node} isLast={isLast} id={anchorId}>
      {interactive ? (
        <Link
          to={`/academy/${topicId}/${courseId}/${lesson.id}`}
          className={`ac-vstep ${active ? 'is-active' : ''} ${watched ? 'is-watched' : ''}`}
        >
          {inner}
        </Link>
      ) : (
        <div className="ac-vstep is-locked">{inner}</div>
      )}
    </CourseStep>
  );
};

export default VideoStep;
